import { Link } from "framework7-react";
import { HTMLAttributes } from "react";

type NavRightNextProps = Required<Pick<HTMLAttributes<HTMLAnchorElement>, "onClick">>;

export function NavRightNext({ onClick }: NavRightNextProps) {
  return (
    <Link
      icon="icon-next"
      onClick={onClick}
    />
  );
}
